import React, { Component } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { jwtDecode } from "jwt-decode";
import {
  clear_session,
  sign_in,
  user_data,
  cart_data,
  license_data,
  order_data
} from "../redux";
import axiosInstance from "../components/axiosInstance";
import { USERS_API_URL } from "../constants"

class AuthRouteInner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuth: false,
      curr_user_data: {},
    };
  }

  async componentDidMount() {
    const navigate = this.props.navigate;
    const location = this.props.location;
    const { auth, session } = this.props;
    let isLoggedIn = this.props.session.isLoggedIn;
    if (
      !location.pathname.includes('home') && !location.pathname.includes('admin')) {
      this.setState({ isAuth: true });
    } else {
      if (auth) {
        const token = localStorage.getItem("accessToken");
        const refreshToken = localStorage.getItem("refreshToken");
        if (!token || !refreshToken) {
          navigate("/shop/login");
        }
        try {
          const { exp } = jwtDecode(refreshToken);
          const curr_time = new Date().getTime() / 1000;
          let token_response = exp >= curr_time;
          if (isLoggedIn) {
            if (!(isLoggedIn && token_response)) {
              navigate("/shop/login");
            } else {
              this.setState({ isAuth: true, curr_user_data: this.props.session.userData });
            }
          } else {
            const resp = await axiosInstance.get(USERS_API_URL + "is_authenticated/");
            const user = await resp.data.user;
            const cart = await resp.data.cart;
            const licenses = await resp.data.licenses;
            const orders = await resp.data.orders;
            const ok = await resp.data.ok;
            this.setState({ curr_user_data: user });
            if (ok) {
              this.props.dispatch(sign_in());
              this.props.dispatch(user_data(user));
              this.props.dispatch(order_data(orders));
              this.props.dispatch(cart_data(cart));
              this.props.dispatch(license_data(licenses));
              this.setState({ isAuth: true });
            } else {
              navigate("/shop/login");
              this.props.dispatch(clear_session())
            }
          }
        } catch (error) {
          console.log(error)
          console.log("TOKEN AUTH Error");
          navigate("/shop/login");
        }
      } else {
        this.setState({ isAuth: true });
      }
    }
  }

  render() {
    const Component = this.props.component;
    return (
      <div style={{ padding: "15px 0px 0px 0px", paddingTop: "0px", margin: "0px" }}>
        {this.state.isAuth ? <Component /> : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  session: state.session,
});

// Higher-order component to inject router props
const AuthRoute = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <AuthRouteInner
      {...props}
      navigate={navigate}
      location={location}
    />
  );
};

export default connect(mapStateToProps)(AuthRoute);
